import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import Slide from "Components/Slide";
import ElementToolbar from "Components/ElementToolbar";
import ElementPropertiesSidebar from "Components/ElementPropertiesSidebar";
import SlidePropertiesSidebar from "Components/SlidePropertiesSidebar";

export default class Whiteboard extends React.Component {

    static propTypes = {
        slide: PropTypes.object.isRequired,
        elementId: PropTypes.string,
        changeElement: PropTypes.func.isRequired
    };

    onMouseDown = () => {
        this.props.changeElement(null);
    };

    render() {
        const {slide, elements, elementId, changeElement} = this.props;
        const currentElement = _.find(elements, ['id', elementId]);

        return <div className='flex flex-row flex-grow'>
            <div className='flex flex-grow flex-col overflow-scroll' onMouseDown={this.onMouseDown}>
                <div key={slide.id} className='m-auto'>
                    <Slide
                        editable
                        slide={slide}
                        currentElementId={elementId}
                        changeElement={changeElement}
                    />

                    <ElementToolbar
                        slide={slide}
                        changeElement={changeElement}
                    />
                </div>
            </div>
            <div className='w-64'>
                {
                    currentElement
                        ? <ElementPropertiesSidebar element={currentElement}/>
                        : <SlidePropertiesSidebar slide={slide}/>
                }
            </div>
        </div>;
    }
}
